export default "__VITE_ASSET__DrOog74j__"